import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../hooks/hooks';
import NexusZonesComponent from '../components/nexus-zones-component';
import PageLoader from '../../../../components/PageLoader';
import { selectZoneQueryItems } from '../../../../redux/zone/selector';
import { zone } from '../../../../redux/zone/action';
import { selectListItems } from '../../../../redux/library/selector';

const ManagementNexusZone = () => {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const parmas: any = useParams()
    const queryItems = useSelector(selectZoneQueryItems)
    const [isQuery, setIsQuery] = useState<boolean>(false)
    const [isLoading, setIsLoading] = useState<boolean>(true)
    const [selectedNexusZones, setSelectedNexusZones] = useState<any>({})
    const libraryData = useSelector(selectListItems)
    const fetchNexusZonesQueryById = () => {
        dispatch(zone.query({
            url: `https://edgegateway.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/nexus_management/global_nexus_zones/fetch-detail`,
            entity: 'NexusZones',
            jsonData: {
                "Context": {},
                Records: [
                    {

                        "Id": parmas?.id,
                    }
                ]
            }
        })).then(() => {
            setIsQuery(true)
        })
    }

    const handleInnerFormChange: any = (event: any, field: string) => {
        setSelectedNexusZones({ ...selectedNexusZones, [field]: event });
    }

    useEffect(() => {
        if (parmas?.id > 0) {
            fetchNexusZonesQueryById()
            setIsLoading(false)
        } else {
            setIsLoading(false)
        }
    }, []
    )

    useEffect(() => {
        if (isQuery) {
            setSelectedNexusZones(queryItems?.result?.items)
        }
    }, [isQuery]
    )

    const handleFormSubmit = async (event: any) => {
        event.preventDefault();
        if (parmas?.id > 0) {
            await dispatch(zone.resetAction({ actionType: 'update' }))
            await dispatch(zone.update({
                url: `https://edgegateway.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/nexus_management/global_nexus_zones`,
                entity: 'NexusZones',
                jsonData: {
                    "Context": {},
                    Records: [

                        {
                            Id: selectedNexusZones?.GlobalNexusZoneId || 0,
                            Name: selectedNexusZones?.Name || '',
                            Code: selectedNexusZones?.Code || '',
                            Description: selectedNexusZones?.Description || '',
                            SLANote: selectedNexusZones?.SLANote || '',
                            Citycode: selectedNexusZones?.Citycode || '',
                            Pincodes: selectedNexusZones?.Pincodes || [],
                            ExpectedDeliveryTime: selectedNexusZones?.ExpectedDeliveryTime || 0,
                            AgentExpectedTimeToReach: selectedNexusZones?.AgentExpectedTimeToReach || 0,
                            DBAId: selectedNexusZones?.DBAId || 0,
                            DBATenantId: selectedNexusZones?.DBATenantId || 0,
                            ZoneClassificationId: selectedNexusZones?.ZoneClassificationId || 0,
                            ZoneRankId: selectedNexusZones?.ZoneRankId || 0,
                            IsExpressDeliveryEnabled: selectedNexusZones?.IsExpressDeliveryEnabled || false,
                            IsReverseDeliveryEnabled: selectedNexusZones?.IsReverseDeliveryEnabled || false,
                            ZoneTypeId: selectedNexusZones?.ZoneTypeId || 0,
                            LifeCycleStatusId: selectedNexusZones?.LifeCycleStatusId || 0,
                            EffectiveFromDateUtc: selectedNexusZones?.EffectiveFromDateUtc,
                            EffectiveToDateUtc: selectedNexusZones?.EffectiveToDateUtc
                        }
                    ]
                }
            })).then(() => {
                back()
            })
        } else {
            await dispatch(zone.resetAction({ actionType: 'create' }))
            await dispatch(zone.create({
                url: `https://edgegateway.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/nexus-management/nexus-a-record-types`,
                entity: 'NexusZones',
                jsonData: {
                    Records: [
                        {
                            "Context": {},
                            "Message": selectedNexusZones
                        }
                    ]
                }
            })).then(() => {
                back()
            })
        }
    }

    const back = () => {
        navigate('/nexus/nexus-management/nexus-zone')
    }

    return (
        <>
            {isLoading ? <PageLoader /> :
                <NexusZonesComponent
                    handleInnerFormChange={handleInnerFormChange}
                    selectedNexusZones={selectedNexusZones}
                    back={back}
                    handleFormSubmit={handleFormSubmit}
                    NexusZoneClassification={libraryData?.result?.NexusZoneClassification}
                    NexusZoneRank={libraryData?.result?.NexusZoneRank}
                    NexusNodeType={libraryData?.result?.NexusNodeType}
                    LifeCycleStatus={libraryData?.result?.LifeCycleStatus}


                />
            }
        </>
    )
}

export default ManagementNexusZone;